import { serviceMaker, methods, api } from "@/http/index.js";

export const getRolesList = () => serviceMaker(`/roles`, methods.GET, api.NGB);
export const createRole = (data) =>
  serviceMaker(
    `/roles/keycloak/clients/${data.client_id}`,
    methods.POST,
    api.NGB,
    data.roleData
  );
export const updateRole = (id, data) =>
  serviceMaker(
    `/roles/keycloak/clients/${id}/roles`,
    methods.PUT,
    api.NGB,
    data
  );
export const getPermissionByRole = (id) =>
  serviceMaker(`/roles/${id}/permissions`, methods.GET, api.NGB);
export const editPermissions = (id, data) =>
  serviceMaker(`/roles/${id}/permissions`, methods.PUT, api.NGB, data);
export const deleteRole = (id) =>
  serviceMaker(`/roles/${id}`, methods.DELETE, api.NGB);

export const getRoleByKeycloakId = (payload) =>
  serviceMaker(
    `/roles/keycloak/clients/${payload.id}/roles`,
    methods.GET,
    api.NGB,
    payload.data
  );
export const getRoleByKeycloakList = () =>
  serviceMaker(`/roles/keycloak/clients`, methods.GET, api.NGB);
